var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gazette"},_vm._l((_vm.gazette),function(item){return _c('a',{attrs:{"href":item.pdf,"target":"_blank"}},[_vm._v("\n    "+_vm._s(item.name)+"\n  ")])}))}
var staticRenderFns = []

export { render, staticRenderFns }